/**
 * Introduction documentation page content.
 *
 * Stored as a raw markdown string so it can be rendered via ReactMarkdown
 * and copied to clipboard as-is for the "Copy as Markdown" feature.
 */

export const introductionContent = `
m8tes is the developer platform for building autonomous AI teammates. Create teammates that run tasks, use tools, and automate workflows — through a Python SDK or REST API.

## Authentication

All API requests require an API key passed in the \`Authorization\` header. API keys start with \`m8_\`.

\`\`\`python
from m8tes import M8tes

client = M8tes(api_key="m8_your_key_here")
# or set M8TES_API_KEY env var and call M8tes() with no args
\`\`\`

\`\`\`bash
curl https://m8tes.ai/api/v2/teammates \\
  -H "Authorization: Bearer m8_your_key_here"
\`\`\`

Get your API key from the [Developer dashboard](https://m8tes.ai/developer) after signing up.

## What You Can Build

- **AI teammates in your product** — embed autonomous teammates with [per-user isolation](/docs/users), [memory](/docs/memories), and [permission controls](/docs/permissions)
- **Automated workflows** — trigger tasks on a [schedule](/docs/scheduling), via [webhook](/docs/webhook-triggers), or by [email](/docs/email-inbox)
- **Streaming experiences** — push [real-time events](/docs/streaming) to your UI as teammates work
- **File generation** — teammates produce [reports, exports, and data files](/docs/files) on demand
- **Human-in-the-loop** — [approval and plan modes](/docs/permissions) let users review before execution

## Next Steps

- [Core Concepts](/docs/core-concepts) — teammates, runs, tasks, triggers, and apps
- [Quick Start](/docs/quickstart) — get your first teammate running in 5 minutes
- [API Reference](/docs/api-reference) — full endpoint documentation
`;
